module.exports = __webpack_public_path__ + "static/media/event-details.7c3cf60b.jpg";